document.addEventListener("DOMContentLoaded", function() {
	jQuery(function($) {
		// FACEBOOK
		$(".share .fb, .m-share .fb").click(function(event) {
			var width = 575,
				height = 680,
				left = ($(window).width() - width) / 2,
				top = ($(window).height() - height) / 2,
				url = this.href,
				opts =
					"status=1" +
					",width=" +
					width +
					",height=" +
					height +
					",top=" +
					top +
					",left=" +
					left;
			window.open(url, "facebook", opts);
			return false;
		});

		// TWITTER
		$(".share .tw, .m-share .tw").click(function(event) {
			var width = 575,
				height = 300,
				left = ($(window).width() - width) / 2,
				top = ($(window).height() - height) / 2,
				url = this.href,
				opts =
					"status=1" +
					",width=" +
					width +
					",height=" +
					height +
					",top=" +
					top +
					",left=" +
					left;
			window.open(url, "twitter", opts);
			return false;
		});

		// LINKEDIN
		$(".share .li, .m-share .li").click(function(event) {
			var width = 575,
				height = 520,
				left = ($(window).width() - width) / 2,
				top = ($(window).height() - height) / 2,
				url = this.href,
				opts =
					"status=1" +
					",width=" +
					width +
					",height=" +
					height +
					",top=" +
					top +
					",left=" +
					left;
			window.open(url, "linkedin", opts);
			return false;
		});

		// PINTEREST
		$(".share .pi, .m-share .pi").click(function(event) {
			var width = 734,
				height = 734,
				left = ($(window).width() - width) / 2,
				top = ($(window).height() - height) / 2,
				url = this.href,
				opts =
					"status=1" +
					",width=" +
					width +
					",height=" +
					height +
					",top=" +
					top +
					",left=" +
					left;

			window.open(url, "linkedin", opts);
			return false;
		});

		// lazy load the images
		$(".blog-content img.size-full").each(function() {
			$(this).attr("data-llsrc", $(this).attr("src"));
			$(this).attr("data-llsrcset", $(this).attr("srcset"));
			$(this).attr("src", "");
			$(this).attr("srcset", "");
			$(this).addClass("srcempty");
		});

		// Cetegory Sidebar
		if (
			$(window).width() > 767 &&
			$("#blog-wrap").height() >
				$("body.archive #content .sidebar .sub .tags").height() + 400 &&
			$(window).height() >
				$("body.archive #content .sidebar .sub .tags").height() + 360
		) {
			$("body.archive #content .sidebar .sub").css(
				"width",
				$("#content .sidebar").width()
			);
			// var height = $('#content .sidebar .sub').height();
			$(window).scroll(function() {
				var scroll = $(this).scrollTop();
				if (
					scroll <
					$("body.archive #content .sidebar").offset().top + 22
				) {
					$("body.archive #content .sidebar .sub").css({
						position: "absolute",
						top: 0,
					});
				} else {
					$("body.archive #content .sidebar .sub").css({
						position: "fixed",
						top: 22,
						// 'height': height
					});
				}
			});
		}

		// read more shortcode
		$("#sc-readmore")
			.nextAll()
			.appendTo("#sc-readmore");
		$("#sc-readmore").hide();
		$(".btn.sc-readmore").click(function() {
			$(this).hide();
			$("#sc-readmore").show();
		});
		// blog home mobile toggles
		$("body.blog .widgettitle").click(function() {
			$(this)
				.parent("div")
				.toggleClass("toggled")
				.siblings()
				.removeClass("toggled");
		});

		// hash links prevent default
		$('a[href="#"]').on("click", function(evt) {
			evt.preventDefault();
		});

    //smooth scroll function - add ss class to trigger element
    $( ".ss" ).on( 'click', function ( event ) {
      if ( this.hash !== "" ) {
        event.preventDefault();
        // Store hash
        var hash = this.hash;
        $( 'html, body' ).animate( {
          scrollTop: $( hash ).offset().top - 80
        }, 800 );
      }
    });
	});
	jQuery(window).on("scroll resize", function() {
		jQuery(".blog-content img.size-full").each(function() {
			if (jQuery(this).hasClass("srcempty")) {
				jQuery(this).attr("src", jQuery(this).attr("data-llsrc"));
				jQuery(this).attr("srcset", jQuery(this).attr("data-llsrcset"));
				jQuery(this).removeClass("srcempty");
			}
		});
	});
});
